const { omit, isEmpty, } = require('lodash');

const { optionLabel, } = require('../lib/consolidationAccountItems');
const { composeChangeFieldNames, composeChangeFields, } = require('./changeField');

const { entries } = Object;

const fixedChangeFieldLabels = {
  acquisition: '取得',
  retirement: '除却',
  sale: '売却',
  impairment: '減損',
  depreciation: '減価償却',
  suspenceTransfer: '建仮振替',
  other: 'その他',
};

const changeFieldNames = (customChangeFields = [], savedOrder, hiddenKeys = []) => composeChangeFieldNames(fixedChangeFieldLabels, customChangeFields, savedOrder, hiddenKeys);

const fields = ({ accountItems = [], otherItems, customChangeFields = [], savedOrder, hiddenKeys = [], } = {}) => {
  const unique = (v, s) => otherItems?.every(o => ['accountItemId'].some(_ => o[_] !== s[_]));
  return {
    accountItemId: {
      label: '勘定科目',
      type: 'select',
      options: accountItems.map(_ => ({ label: optionLabel(_), value: _.id })),
      validations: {
        required: v => v != null,
        unique,
      },
    },
    opening: {
      label: '期首',
      type: 'float',
      validations: {
        required: v => v != null,
      },
    },
    ...composeChangeFields(fixedChangeFieldLabels, customChangeFields, savedOrder, hiddenKeys),
  };
};

exports.fields = fields;
exports.changeFieldNames = changeFieldNames;
exports.fixedChangeFieldLabels = fixedChangeFieldLabels;
